<script lang="ts" setup>
import { resources } from '../config/brands'
</script>

<template>
  <div class="flex flex-col" style="gap: 20px">
    <!-- 两个 logo，和 nav 保持一致 -->
    <div class="flex items-center" style="gap: 16px">
      <img :src="resources.logo || ''" alt="logo icon" style="width: 30px; height: 30px; object-fit: contain">
      <img :src="resources.novelText || ''" alt="logo text" style="height: 20px; width: auto; object-fit: contain">
    </div>
    <!-- 品牌文案 -->
    <div>
      <p style="font-size: 16px; color: #FFFFFF; line-height: 1.6">
        Stream Anytime, Anywhere. The
      </p>
      <p style="font-size: 16px; color: #FFFFFF; line-height: 1.6">
        Entertainment Never Ends
      </p>
    </div>
  </div>
</template>
